import React, { useState } from 'react'
import Select from 'react-select';
import { DatePicker } from 'antd';
import moment from 'moment';
import UploadActiveInventory from './UploadActiveInventory';

const ActivityInventory = () => {

    const [startDate, setStartDate] = useState(moment()?.startOf());
    const [selectDate, setSelectDate] = useState(null);
    const DisplayDateRange = 10;

    const [show, setShow] = useState(false);

    const list = [
        { label: 'item 1', value: 1 },
        { label: 'item 2', value: 2 },
        { label: 'item 3', value: 3 },
        { label: 'item 4', value: 4 },
    ]


    const handleSelectDateChange = (date) => {
        setSelectDate(date)
        setStartDate(date ? date : moment()?.startOf())
    }

    const goToPreviousDays = () => {
        setStartDate(startDate?.clone()?.subtract(DisplayDateRange, 'days'));
    }
    const goToNextDays = () => {
        setStartDate(startDate?.clone()?.add(DisplayDateRange, 'days'));
    }

    const renderCalendar = () => {
        const days = [];
        let currentDate = startDate?.clone();
        for (let i = 0; i < DisplayDateRange; i++) {
            days.push(
                <th key={currentDate.format('YYYY-MM-DD')}>
                    <div className="fw-bold fs-6"> {currentDate.format('ddd')} </div>
                    <div className="fs_14"> {Number(currentDate.format('D')) > 9 ? currentDate.format('D') : '0' + currentDate.format('D')}-{currentDate.format('MMM')} </div>
                </th>
            )
            currentDate = currentDate?.add(1, 'day')
        }
        return days;
    }

    const getInputElements = (name) => {
        const inputs = [];
        for (let i = 0; i < DisplayDateRange; i++) {
            inputs?.push(
                <td key={`${name}${i}`} >
                    <input type="text" name="" id="" />
                </td>
            )
        }
        return inputs;
    }

    return (
        <div className="container-fluid" >
            <div className="mt-4 heading_color">
                <h3>Inventory Availability </h3>
            </div>

            <ul className='activity-legend'>
                <li className='green' >Available</li>
                <li className='red'>Sold Out</li>
            </ul>

            <div className="border p-3 text-center rounded-top">
                <div className="row row-cols-1 row-cols-xl-5 row-cols-lg-3 row-cols-md-3 g-2 g-lg-3 justify-content-center align-items-center">
                    <div className="col">
                        <Select
                            className="dropdown select_dropdown text-start"
                            inputId='ActivityId'
                            options={list}
                            isSearchable
                            placeholder='Activity Name'
                        />
                    </div>
                    <div className="col">
                        <DatePicker
                            className='antd_input w-100'
                            format='DD/MM/YYYY'
                            placeholder="DD/MM/YYYY"
                            value={selectDate}
                            onChange={handleSelectDateChange}
                        />
                    </div>
                    <div className="col">
                        <button type="button" className='btn btn-primary' >Bulk Upload</button>
                    </div>
                    <div className="col">
                        <button type="button" className='btn btn-primary' onClick={goToPreviousDays} >Previous 10 Days</button>
                    </div>
                    <div className="col">
                        <button type="button" className='btn btn-primary' onClick={goToNextDays} >Next 10 Days</button>
                    </div>
                </div>
            </div>

            <div className='activity-table border rounded-bottom'>
                <table className='w-100'>
                    <thead>
                        <th colSpan={2} className='activity-first-column' > <div></div> </th>
                        {renderCalendar()}
                    </thead>
                    <tbody>
                        <tr>
                            <td colSpan={2} className='activity-first-column' >
                                <div >
                                    Activity Varient Type
                                </div>
                            </td>
                            {getInputElements("ActivityVarientType")}
                        </tr>
                        <tr>
                            <td colSpan={2} className='activity-first-column' >
                                <div >
                                    Time slots
                                </div>
                            </td>
                            {getInputElements("Timeslots")}
                        </tr>
                        <tr>
                            <td colSpan={2} className='activity-first-column' >
                                <div >
                                    Activity Varient Type
                                </div>
                            </td>
                            {getInputElements("ActivityVarientType2")}
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="mt-5">
                <div className="d-flex justify-content-center align-items-center">
                    <button type="button" className='btn btn-primary mx-1'> Cancel </button>
                    <button type="button" className='btn btn-primary mx-1'> Save </button>
                    <button type="button" className='btn btn-primary mx-1' onClick={() => setShow(true)} > Temp </button>
                </div>
            </div>
            <UploadActiveInventory show={show} setShow={setShow} />
        </div>
    )
}

export default ActivityInventory
